var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Update NDR In Runsheet")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingID')
    },
    attrs: {
      "id": "ShippingID",
      "type": "text",
      "name": "ShippingID",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShippingID')),
      expression: "errors.has('form-1.ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Enter Shipping ID"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.shipmenttypeList,
      "selected-option": _vm.shipmenttypeObj,
      "name": "shipmenttype",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "select": _vm.selectshipmenttype
    },
    model: {
      value: (_vm.shipmenttype),
      callback: function($$v) {
        _vm.shipmenttype = $$v
      },
      expression: "shipmenttype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shipmenttype')),
      expression: "errors.has('form-1.shipmenttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Select Shipment Type"))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("NDR Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.NDRList,
      "selected-option": _vm.NDRItemObj,
      "name": "NDR",
      "placeholder": "Select NDRCode"
    },
    on: {
      "select": _vm.selectNDR
    },
    model: {
      value: (_vm.NDR),
      callback: function($$v) {
        _vm.NDR = $$v
      },
      expression: "NDR"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.NDR')),
      expression: "errors.has('form-1.NDR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Select NDR "))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Ticket ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa-ticket'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticketId),
      expression: "ticketId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "ticketId",
      "type": "text",
      "name": "ticketId",
      "placeholder": "Enter Ticket ID"
    },
    domProps: {
      "value": (_vm.ticketId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ticketId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ticketId')),
      expression: "errors.has('form-1.ticketId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s("Please Enter Ticket Id"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading == true
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Update")]), _vm._v("    \n                  "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b944e45","hasScoped":true}!./src/views/components/UpdateNDR/UpdateNDR.component.html
// module id = 1410
// module chunks = 1